export const PRIMARY = '#E73B27';
export const SECONDARY = '#00174f';
export const RED = '#ED6D48';
export const GREEN = '#42B549';
